import React from 'react';

import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import AiSparkleIcon from '@atlaskit/icon/core/ai-sparkle';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import type { AIImageGenerationPlugin } from './aiImageGenerationPluginType';
import { showAIImageGenerationPopup } from './pm-plugins/actions';
import { createImageGenPlugin } from './pm-plugins/main';
import { pluginKey } from './pm-plugins/plugin-key';
import { AIImageGenerationPopup } from './ui/AIImageGenerationPopup';

export const aiImageGenerationPlugin: AIImageGenerationPlugin = ({ api }) => {
	return {
		name: 'aiImageGeneration',

		pmPlugins() {
			return [
				{
					name: 'aiImageGeneration',
					plugin: () => createImageGenPlugin(),
				},
			];
		},

		getSharedState(editorState) {
			if (!editorState) {
				return { isOpen: false };
			}
			const state = pluginKey.getState(editorState);
			if (!state) {
				return { isOpen: false };
			}
			return { isOpen: state.isOpen };
		},

		commands: {
			showAIImageGenerationPopup:
				() =>
				({ tr }) =>
					showAIImageGenerationPopup(tr),
		},

		contentComponent: ({
			editorView,
			popupsMountPoint,
			popupsBoundariesElement,
			popupsScrollableElement,
		}) => {
			if (!editorView) {
				return null;
			}

			return (
				<AIImageGenerationPopup
					api={api}
					editorView={editorView}
					popupsMountPoint={popupsMountPoint}
					popupsBoundariesElement={popupsBoundariesElement}
					popupsScrollableElement={popupsScrollableElement}
				/>
			);
		},

		pluginsOptions: {
			quickInsert: ({ formatMessage }) => {
				if (!expValEquals('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
					return [];
				}

				const title = formatMessage(messages.aiImageGeneration);

				return [
					{
						id: 'aiImageGeneration',
						title,
						description: formatMessage(messages.aiImageGenerationDescription),
						priority: 500,
						keywords: ['ai', 'generate', 'image', 'create', 'picture'],
						icon: () => <AiSparkleIcon label={title} color="currentColor" />,
						isDisabledOffline: true,
						action(insert) {
							const tr = insert('');
							api?.aiImageGeneration.commands.showAIImageGenerationPopup()({ tr });
							return tr;
						},
					},
				];
			},
		},
	};
};
